import React, { useEffect, useRef } from "react";
import Moment from "react-moment";
import { debounce } from "../utils/debounce";
import { HAS_EVENT_TIMEZONE_SUPPORT } from "../utils/consts";

const SideMeetingDetails = ({ sidebarCollapsed, meetingDetails }) => {
  const sidebarRef = useRef();

  useEffect(() => {
    const handleResize = debounce(() => {
      const { current: sidebarEl } = sidebarRef;

      if (sidebarEl) {
        sidebarEl.style.width = sidebarEl.parentNode.offsetWidth + "px";
      }
    }, 350);

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [sidebarCollapsed]);

  return (
    <>
      <div
        ref={sidebarRef}
        className="context-sidebar col-sm-12 col-md-4 col-xl-3 px-0 vh-100 border-left fixed-md"
      >
        <div className="side-meeting-details-card">
          <h6 className="side-meeting-details-title">Meeting title:</h6>
          <h5 className="side-meeting-details-text">
            {meetingDetails.EventName}
          </h5>
          <br />
          <h6 className="side-meeting-details-title">Time:</h6>
          <h6 className="side-meeting-details-text">
            <Moment format="h:mma">
              {HAS_EVENT_TIMEZONE_SUPPORT
                ? meetingDetails.EventStartTimeWithTz
                : meetingDetails.EventStartTime}
            </Moment>
            , &nbsp;
            <Moment format="MMMM DD">
              {HAS_EVENT_TIMEZONE_SUPPORT
                ? meetingDetails.EventStartTimeWithTz
                : meetingDetails.EventStartTime}
            </Moment>
          </h6>
          {meetingDetails.Notes && (
            <>
              <br />
              <h6 className="side-meeting-details-title">Description:</h6>
              <h6 className="side-meeting-details-text">
                {meetingDetails.Notes}
              </h6>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SideMeetingDetails;
